import { Component, OnInit } from '@angular/core'
import { FormFieldFactoryComponentAbstract } from '../../core/component/form-field-factory/form-field-factory.component-abstract'

@Component({
    selector: 'mga-form-factory-field-autocomplete',
    templateUrl: './form-factory-field-autocomplete.component.html',
    styleUrls: ['./form-factory-field-autocomplete.component.scss'],
})
export class FormFactoryFieldAutocompleteComponent extends FormFieldFactoryComponentAbstract {}
